import Dropdown from "react-bootstrap/Dropdown";
import React, { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";

// Import Swiper styles
import "swiper/css";
import { Pagination } from "swiper";
import { parseHtml, toWebp } from "../../../utils/common";
import styles from "./style.module.scss";
import { Col, Row } from "react-bootstrap";

const CoreServiceMobile = (props) => {
    const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

    const { data } = props;

    const [selectedDropdownIndex, setSelectedDropdownIndex] = useState(0);
    const [selectedDropdownTitle, setSelectedDropdownTitle] = useState(
        data?.Keypoint[0].title
    );

    const swiperRef = useRef(null);

    const handleDropdownItemClick = (index, title) => {
        setSelectedDropdownIndex(index);
        setSelectedDropdownTitle(title);
        if (swiperRef.current) {
            swiperRef.current.slideTo(index + 1);
        }
    };

    return (
        <div>
            <div className={styles["core-sticky-heading"]}>
                <div className={styles["core-service-heading"]}>
                    <h2>{data?.title}</h2>
                    <p>{data?.display_title}</p>

                </div>
                <Dropdown className={styles["industry-sm-dropdown"]}>
                    <Dropdown.Toggle
                        className={`${styles["dropdown-toggle"]} border-color border-2 bg-white text-small text-black font-medium`}
                        variant="success"
                        id="dropdown-basic"
                    >
                        <span>{selectedDropdownTitle}</span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={styles["dropdown-menu"]}>
                        {data?.Keypoint &&
                            data?.Keypoint.map((key, i) => (
                                <Dropdown.Item
                                    className={styles["dropdown-item"]}
                                    href="#"
                                    key={`${i}_h`}
                                    onClick={() => handleDropdownItemClick(i, key?.title)}
                                >
                                    {key?.title}
                                </Dropdown.Item>
                            ))}
                    </Dropdown.Menu>
                </Dropdown>
            </div>


            <div className={styles["indutry-tab-content"]}>
                <Swiper
                    slidesPerView="1"
                    initialSlide={selectedDropdownIndex || 1}
                    loop={true}
                    pagination={{
                        clickable: true,
                    }}
                    spaceBetween={30}
                    autoplay={{ delay: 4000 }}
                    modules={[Pagination]}
                    className={styles["mySwiper swiper"]}
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                >
                    {data?.Keypoint &&
                        data?.Keypoint.map((keypoint, i) => (
                            <SwiperSlide
                                key={`${i}_k`}
                                className={styles["swiper-slide"]}
                            >
                                <div className={`${styles["core-service-card"]}`}>
                                    <Row>
                                        <Col lg={8} sm={12}>
                                            <div
                                                className={
                                                    styles["core-service-card-content"]
                                                }
                                            >
                                                <h4>{keypoint?.title}</h4>
                                                <p>{parseHtml(keypoint?.description)}</p>
                                            </div>
                                            <div
                                                className={
                                                    styles["core-service-card-features"]
                                                }
                                            >
                                                <h6>
                                                    {keypoint?.features_title
                                                        ? keypoint?.features_title
                                                        : "Core Service"}
                                                </h6>

                                                <div
                                                    className={
                                                        styles["core-feature-items"]
                                                    }
                                                >
                                                    {keypoint?.points?.map((point, index) => (
                                                        <React.Fragment key={index}>
                                                            <p>
                                                                {point.title}
                                                            </p>
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={4} sm={12}>
                                            <div
                                                className={` ${styles["core-service-card-image"]}`}
                                            >
                                                {keypoint?.image?.data && (
                                                    <Image
                                                        height={326}
                                                        width={421}
                                                        quality={100}
                                                        loading="lazy"
                                                        alt={
                                                            keypoint?.image?.data?.attributes
                                                                ?.name || "Image"
                                                        }
                                                        src={
                                                            keypoint?.image?.data?.attributes?.url
                                                                ? toWebp(
                                                                    `${baseUrl}${keypoint?.image?.data?.attributes?.url}`
                                                                )
                                                                : null
                                                        }
                                                    />
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </SwiperSlide>
                        ))}
                </Swiper>
            </div>
        </div>
    );
};

export default CoreServiceMobile;
